import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {NavButton} from '~/common/fabric/CreateDesign/components/NavBottom/NavButton';
import {CardDesignIcon} from '~library/svg/CardDesignIcon';
import {DiagonalLinesIcon} from '~library/svg/DiagonalLinesIcon';
import {MailIcon} from '~library/svg/MailIcon';
import {PostStampIcon} from '~library/svg/PostStampIcon';
import {charcoal} from '~libSass/base/_exports.sass';

export const CardFeaturesPanel = () => (
  <>
    <NavButton
      title="Card design"
      icon={<CardDesignIcon color={charcoal} />}
      section={Sections.CARD_DESIGN}
      disableAutoOpenEditor
    />
    <NavButton
      title="Envelope & liner"
      icon={<MailIcon color={charcoal} />}
      section={Sections.ENVELOPE_LINER}
    />
    <NavButton
      title="Stamp & stickers"
      icon={<PostStampIcon color={charcoal} />}
      section={Sections.STAMP}
    />
    <NavButton
      title="Background"
      icon={<DiagonalLinesIcon color={charcoal} />}
      section={Sections.BACKGROUND}
    />
  </>
);
